import { differenceInYears } from 'date-fns';

export default function calculateAge(dateOfBirthIso, dateOfDeathIso) {
  return differenceInYears(new Date(dateOfDeathIso), new Date(dateOfBirthIso));
}
